const DOCUMENT_TITLE = 'Import';

export const ImportRoutes = [
  {
    path: '/IportLargeFiles',
    name: 'Import Large Files',
    meta: {
      title: DOCUMENT_TITLE,
    },
    component: () => import('../views/bulk/ImportLargeFiles.vue'),
  },
  {
    path: '/cronJobs',
    name: 'Cron Jobs',
    meta: {
      title: 'cronJobs Status',
    },
    component: () => import('../views/bulk/CronJobs.vue'),
  },
];

export default ImportRoutes;
